<template>
  <div>
    <div class="feedback">
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <IndexPageTopCoverSection @error="onSectionError" />
    <IndexPageNoticeListSection />
    <IndexPageEspeciallyRecommendSection />
    <IndexPageRecommendSection />
    <IndexPageBrandSection data-gtm-page="top" />
    <IndexPageSpecialListSection @error="onSectionError" />

    <div class="dual_section">
      <div class="dual_section__wrap">
        <IndexPageSceneListSection data-gtm-page="top" />
        <IndexPageReceivingKindsSection />
      </div>
    </div>
    <IndexPageNewArrivalSection />
    <IndexPageItemSkuBookmarkSection />
    <IndexPageCardDesignSection />
    <IndexPageCategoriesSection data-gtm-page="top" @error="onSectionError" />
    <IndexPageGifteeColumnListSection @error="onSectionError" />
    <IndexPageBackToTopSection @click-link="onClickBackTopLink" />
  </div>
</template>
<script>
import IndexPageTopCoverSection from '../../organism/homes/sections/IndexPageTopCoverSection.vue'
import IndexPageRecommendSection from '../../organism/homes/sections/IndexPageRecommendSection.vue'
import IndexPageBrandSection from '../../organism/homes/sections/IndexPageBrandSection.vue'
import IndexPageSpecialListSection from '../../organism/homes/sections/IndexPageSpecialListSection.vue'
import IndexPageNoticeListSection from '../../organism/homes/sections/IndexPageNoticeListSection.vue'
import IndexPageNewArrivalSection from '../../organism/homes/sections/IndexPageNewArrivalSection.vue'
import IndexPageItemSkuBookmarkSection from '../../organism/homes/sections/IndexPageItemSkuBookmarkSection.vue'
import IndexPageCardDesignSection from '../../organism/homes/sections/IndexPageCardDesignSection.vue'
import IndexPageSceneListSection from '../../organism/homes/sections/IndexPageSceneListSection.vue'
import IndexPageReceivingKindsSection from '../../organism/homes/sections/IndexPageReceivingKindsSection.vue'
import IndexPageCategoriesSection from '../../organism/homes/sections/IndexPageCategoriesSection.vue'
import IndexPageGifteeColumnListSection from '../../organism/homes/sections/IndexPageGifteeColumnListSection.vue'
import IndexPageBackToTopSection from '../../organism/homes/sections/IndexPageBackToTopSection.vue'
import FeedbackError from '../../atoms/feedbacks/feedback-error.vue'
import IndexPageEspeciallyRecommendSection from '../../organism/homes/sections/IndexPageEspeciallyRecommendSection.vue'

export default {
  components: {
    IndexPageEspeciallyRecommendSection,
    IndexPageTopCoverSection,
    IndexPageRecommendSection,
    IndexPageBrandSection,
    IndexPageSpecialListSection,
    IndexPageNoticeListSection,
    IndexPageNewArrivalSection,
    IndexPageItemSkuBookmarkSection,
    IndexPageCardDesignSection,
    IndexPageSceneListSection,
    IndexPageReceivingKindsSection,
    IndexPageCategoriesSection,
    IndexPageGifteeColumnListSection,
    IndexPageBackToTopSection,
    FeedbackError
  },
  props: {
    redirectSourceErrorMessage: {
      type: String,
      required: true
    },
    deliveryUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showableErrorFeedback: false
    }
  },
  mounted() {
    this.showableErrorFeedback = this.redirectSourceErrorMessage.length !== 0
    this.errorMessage = this.redirectSourceErrorMessage
  },
  methods: {
    moveToUrl(url) {
      location.href = url
      this.closeModal()
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    onSectionError(message) {
      this.errorMessage = message
      this.showableErrorFeedback = true
    },
    onClickBackTopLink() {
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}
</script>
